
<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">品種グループ詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save()" :disabled="!valid">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="所属事業本部"
                clearable
                v-model="root.buId"
                url="/divisions/kv?type=BU"
              >
              </remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="所属BU"
                clearable
                v-model="root.businessUnitId"
                :url="`/divisions/kv?type=BUSINESS_UNIT&buId=${root.buId}`"
              >
              </remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout :key="index" row v-for="(item, index) in form" wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="item.label"
                :readonly="item.isId"
                :rules="
                  item.required
                    ? [(v) => !!v || `${item.label} is required`]
                    : []
                "
                v-model="root[item.name]"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: null,
      id: null,
      root: {},
      form: [
        // { label: '品種グループCD', name: 'code', required: true, isId: true },
        { label: '品種グループ名', name: 'name', required: true },
      ],
    }
  },
  methods: {
    returnToList() {
      this.$router.push({
        name: 'M0270',
      })
    },
    initData() {
      this.root.code = this.$route.query.code
      this.root.name = this.$route.query.name
    },
    save() {
      this.$http
        .post(`/product-groups`, this.root)
        .then(() => {
          this.returnToList()
          this.$message('', 'Success')
        })
        .catch(() => {
          this.$message('', 'Error')
        })
    },
  },
  mounted() {
    this.initData()
  },
}
</script>
